<template>
  <div class="editor">
    <div id="tinyEditor"></div>
  </div>
</template>
<script>
import tinymce from "tinymce";
export default {
  name: 'TinyEditor',
  props: {
    modelo:{
      type: String,
      default: null
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data(){
    return {
    }
  },
  mounted() {
    const configs = {
      selector: '#tinyEditor',
      language: 'pt_BR',
      // disabled_plugins: 'contextmenu colorpicker fullpage textcolor',
      // print paste hr toc imagetools textpattern
      plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help',
      toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | image table',
      image_advtab: true,
      paste_data_images: true,
      image_title: true,
      automatic_uploads: true,
      file_picker_types: 'image',
      branding: false,
      height: this.height,
      // images_upload_url: 'hal/public/arquivos',
      setup: function (ed) {
        ed.on('init', function () {});
      },
      file_picker_callback: function (cb, value, meta) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.onchange = function () {
          const file = this.files[0];

          const reader = new FileReader();
          reader.onload = function () {
            const id = 'blobid' + (new Date()).getTime()
            let blobCache = tinymce.activeEditor.editorUpload.blobCache
            // console.dir(reader.result.split([1]))
            const base64 = reader.result
            const blobInfo = blobCache.create(id, file, base64)
            blobCache.add(blobInfo);

            cb(blobInfo.blobUri(), {title: file.name, alt: file.name})
          };
          reader.readAsDataURL(file);
        };

        input.click();
        // document.getElementById('fileSelector').click()
      },
      // images_upload_handler: (blobInfo, success) => {
      //   console.dir(blobInfo)
      //   console.dir(success)
      // }
    }

    tinymce.init(configs);
  },
  methods:{
  },
  watch:{
    modelo:{
      handler(novoValor){
        tinymce.activeEditor.setContent(novoValor);
      }
    }
  },
  beforeDestroy() {
    tinymce.remove()
  }
}
</script>
<style lang="stylus">
.editor
  //padding-bottom 100px
  margin-left 15px
  margin-right 15px

.tox-promotion-link
  visibility hidden

.tox-tinymce
  border-color grey !important
  //box-shadow: 0 1px 2px rgb(0 0 0 / 0.2) !important;

//.tox-statusbar__branding
//  visibility hidden
</style>